var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Flex } from 'antd-mobile';
import React, { Component } from 'react';
import { px2rem } from 'smartpi-core';
import styled from 'styled-components';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var SelectProvice = styled.select(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-left: ", ";\n  padding-right: ", ";\n  height: ", ";\n  width: 100%;\n  font-weight: normal;\n  color: #aa661d;\n  background: transparent;\n  font-size: ", ";\n  appearance: none;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  z-index: 200;\n"], ["\n  padding-left: ", ";\n  padding-right: ", ";\n  height: ", ";\n  width: 100%;\n  font-weight: normal;\n  color: #aa661d;\n  background: transparent;\n  font-size: ", ";\n  appearance: none;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  z-index: 200;\n"])), px2rem(20), px2rem(45), px2rem(70), px2rem(28));
var SelectCity = styled.select(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-left: ", ";\n  padding-right: ", ";\n  height: ", ";\n  width: ", ";\n  font-weight: normal;\n  color: #aa661d;\n  background: transparent;\n  font-size: ", ";\n  appearance: none;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  z-index: 200;\n"], ["\n  padding-left: ", ";\n  padding-right: ", ";\n  height: ", ";\n  width: ", ";\n  font-weight: normal;\n  color: #aa661d;\n  background: transparent;\n  font-size: ", ";\n  appearance: none;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  z-index: 200;\n"])), px2rem(20), px2rem(45), px2rem(70), px2rem(210), px2rem(28));
var LabelProvice = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  margin-left: ", ";\n  position: relative;\n  &::before {\n    content: '';\n    height: 0;\n    width: 0;\n    border-style: solid;\n    border-width: ", " ", ";\n    border-color: rgba(170, 102, 29, 1) transparent transparent transparent;\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    z-index: 100;\n  }\n  /* &::after {\n    content: '';\n    height: 100%;\n    width: 100%;\n    display: inline-block;\n    background: #f5f5f5;\n    position: absolute;\n    top: 0;\n    border-radius: ", ";\n  } */\n"], ["\n  width: ", ";\n  height: ", ";\n  margin-left: ", ";\n  position: relative;\n  &::before {\n    content: '';\n    height: 0;\n    width: 0;\n    border-style: solid;\n    border-width: ", " ", ";\n    border-color: rgba(170, 102, 29, 1) transparent transparent transparent;\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    z-index: 100;\n  }\n  /* &::after {\n    content: '';\n    height: 100%;\n    width: 100%;\n    display: inline-block;\n    background: #f5f5f5;\n    position: absolute;\n    top: 0;\n    border-radius: ", ";\n  } */\n"])), function (props) { return (props.isCityOptionVisible ? px2rem(210) : px2rem(440)); }, px2rem(70), px2rem(20), px2rem(16), px2rem(12), px2rem(25), px2rem(10), px2rem(8));
var LabelCity = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  margin-left: ", ";\n  &::before {\n    content: '';\n    height: 0;\n    width: 0;\n    border-style: solid;\n    border-width: ", " ", ";\n    border-color: rgba(170, 102, 29, 1) transparent transparent transparent;\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    z-index: 100;\n  }\n  &::after {\n    content: '';\n    height: ", ";\n    width: 35%;\n    display: inline-block;\n    background: #f5f5f5;\n    position: absolute;\n    top: 0;\n    right: 0;\n    border-radius: ", ";\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  margin-left: ", ";\n  &::before {\n    content: '';\n    height: 0;\n    width: 0;\n    border-style: solid;\n    border-width: ", " ", ";\n    border-color: rgba(170, 102, 29, 1) transparent transparent transparent;\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    z-index: 100;\n  }\n  &::after {\n    content: '';\n    height: ", ";\n    width: 35%;\n    display: inline-block;\n    background: #f5f5f5;\n    position: absolute;\n    top: 0;\n    right: 0;\n    border-radius: ", ";\n  }\n"])), px2rem(210), px2rem(70), px2rem(20), px2rem(16), px2rem(12), px2rem(25), px2rem(10), px2rem(70), px2rem(8));
var provincesAndCities = [
    { name: '北京市', cities: ['北京市'] },
    { name: '天津市', cities: ['天津市'] },
    {
        name: '河北省',
        cities: [
            '石家庄市',
            '唐山市',
            '秦皇岛市',
            '邯郸市',
            '邢台市',
            '保定市',
            '张家口市',
            '承德市',
            '沧州市',
            '廊坊市',
            '衡水市',
        ],
    },
    {
        name: '山西省',
        cities: [
            '太原市',
            '大同市',
            '阳泉市',
            '长治市',
            '晋城市',
            '朔州市',
            '晋中市',
            '运城市',
            '忻州市',
            '临汾市',
            '吕梁市',
        ],
    },
    {
        name: '内蒙古',
        cities: [
            '呼和浩特市',
            '包头市',
            '乌海市',
            '赤峰市',
            '通辽市',
            '鄂尔多斯市',
            '呼伦贝尔市',
            '巴彦淖尔市',
            '乌兰察布市',
            '兴安盟',
            '锡林郭勒盟',
            '阿拉善盟',
        ],
    },
    {
        name: '辽宁省',
        cities: [
            '沈阳市',
            '大连市',
            '鞍山市',
            '抚顺市',
            '本溪市',
            '丹东市',
            '锦州市',
            '营口市',
            '阜新市',
            '辽阳市',
            '盘锦市',
            '铁岭市',
            '朝阳市',
            '葫芦岛市',
        ],
    },
    {
        name: '吉林省',
        cities: ['长春市', '吉林市', '四平市', '辽源市', '通化市', '白山市', '松原市', '白城市', '延边朝鲜族自治州'],
    },
    {
        name: '黑龙江省',
        cities: [
            '哈尔滨市',
            '齐齐哈尔市',
            '鸡西市',
            '鹤岗市',
            '双鸭山市',
            '大庆市',
            '伊春市',
            '佳木斯市',
            '七台河市',
            '牡丹江市',
            '黑河市',
            '绥化市',
            '大兴安岭地区',
        ],
    },
    { name: '上海市', cities: ['上海市'] },
    {
        name: '江苏省',
        cities: [
            '南京市',
            '无锡市',
            '徐州市',
            '常州市',
            '苏州市',
            '南通市',
            '连云港市',
            '淮安市',
            '盐城市',
            '扬州市',
            '镇江市',
            '泰州市',
            '宿迁市',
        ],
    },
    {
        name: '浙江省',
        cities: [
            '杭州市',
            '宁波市',
            '温州市',
            '嘉兴市',
            '湖州市',
            '绍兴市',
            '金华市',
            '衢州市',
            '舟山市',
            '台州市',
            '丽水市',
        ],
    },
    {
        name: '安徽省',
        cities: [
            '合肥市',
            '芜湖市',
            '蚌埠市',
            '淮南市',
            '马鞍山市',
            '淮北市',
            '铜陵市',
            '安庆市',
            '黄山市',
            '滁州市',
            '阜阳市',
            '宿州市',
            '六安市',
            '亳州市',
            '池州市',
            '宣城市',
        ],
    },
    {
        name: '福建省',
        cities: ['福州市', '厦门市', '莆田市', '三明市', '泉州市', '漳州市', '南平市', '龙岩市', '宁德市'],
    },
    {
        name: '江西省',
        cities: [
            '南昌市',
            '景德镇市',
            '萍乡市',
            '九江市',
            '新余市',
            '鹰潭市',
            '赣州市',
            '吉安市',
            '宜春市',
            '抚州市',
            '上饶市',
        ],
    },
    {
        name: '山东省',
        cities: [
            '济南市',
            '青岛市',
            '淄博市',
            '枣庄市',
            '东营市',
            '烟台市',
            '潍坊市',
            '济宁市',
            '泰安市',
            '威海市',
            '日照市',
            '莱芜市',
            '临沂市',
            '德州市',
            '聊城市',
            '滨州市',
            '菏泽市',
        ],
    },
    {
        name: '河南省',
        cities: [
            '郑州市',
            '开封市',
            '洛阳市',
            '平顶山市',
            '安阳市',
            '鹤壁市',
            '新乡市',
            '焦作市',
            '濮阳市',
            '许昌市',
            '漯河市',
            '三门峡市',
            '南阳市',
            '商丘市',
            '信阳市',
            '周口市',
            '驻马店市',
        ],
    },
    {
        name: '湖北省',
        cities: [
            '武汉市',
            '黄石市',
            '十堰市',
            '宜昌市',
            '襄阳市',
            '鄂州市',
            '荆门市',
            '孝感市',
            '荆州市',
            '黄冈市',
            '咸宁市',
            '随州市',
            '恩施土家族苗族自治州',
        ],
    },
    {
        name: '湖南省',
        cities: [
            '长沙市',
            '株洲市',
            '湘潭市',
            '衡阳市',
            '邵阳市',
            '岳阳市',
            '常德市',
            '张家界市',
            '益阳市',
            '郴州市',
            '永州市',
            '怀化市',
            '娄底市',
            '湘西土家族苗族自治州',
        ],
    },
    {
        name: '广东省',
        cities: [
            '广州市',
            '韶关市',
            '深圳市',
            '珠海市',
            '汕头市',
            '佛山市',
            '江门市',
            '湛江市',
            '茂名市',
            '肇庆市',
            '惠州市',
            '梅州市',
            '汕尾市',
            '河源市',
            '阳江市',
            '清远市',
            '东莞市',
            '中山市',
            '潮州市',
            '揭阳市',
            '云浮市',
        ],
    },
    {
        name: '广西',
        cities: [
            '南宁市',
            '柳州市',
            '桂林市',
            '梧州市',
            '北海市',
            '防城港市',
            '钦州市',
            '贵港市',
            '玉林市',
            '百色市',
            '贺州市',
            '河池市',
            '来宾市',
            '崇左市',
        ],
    },
    { name: '海南省', cities: ['海口市', '三亚市', '三沙市', '儋州市'] },
    { name: '重庆市', cities: ['重庆市'] },
    {
        name: '四川省',
        cities: [
            '成都市',
            '自贡市',
            '攀枝花市',
            '泸州市',
            '德阳市',
            '绵阳市',
            '广元市',
            '遂宁市',
            '内江市',
            '乐山市',
            '南充市',
            '眉山市',
            '宜宾市',
            '广安市',
            '达州市',
            '雅安市',
            '巴中市',
            '资阳市',
            '阿坝藏族羌族自治州',
            '甘孜藏族自治州',
            '凉山彝族自治州',
        ],
    },
    {
        name: '贵州省',
        cities: [
            '贵阳市',
            '六盘水市',
            '遵义市',
            '安顺市',
            '毕节市',
            '铜仁市',
            '黔西南布依族苗族自治州',
            '黔东南苗族侗族自治州',
            '黔南布依族苗族自治州',
        ],
    },
    {
        name: '云南省',
        cities: [
            '昆明市',
            '曲靖市',
            '玉溪市',
            '保山市',
            '昭通市',
            '丽江市',
            '普洱市',
            '临沧市',
            '楚雄彝族自治州',
            '红河哈尼族彝族自治州',
            '文山壮族苗族自治州',
            '西双版纳傣族自治州',
            '大理白族自治州',
            '德宏傣族景颇族自治州',
            '怒江傈僳族自治州',
            '迪庆藏族自治州',
        ],
    },
    { name: '西藏', cities: ['拉萨市', '日喀则市', '昌都市', '林芝市', '山南市', '那曲地区', '阿里地区'] },
    {
        name: '陕西省',
        cities: ['西安市', '铜川市', '宝鸡市', '咸阳市', '渭南市', '延安市', '汉中市', '榆林市', '安康市', '商洛市'],
    },
    {
        name: '甘肃省',
        cities: [
            '兰州市',
            '嘉峪关市',
            '金昌市',
            '白银市',
            '天水市',
            '武威市',
            '张掖市',
            '平凉市',
            '酒泉市',
            '庆阳市',
            '定西市',
            '陇南市',
            '临夏回族自治州',
            '甘南藏族自治州',
        ],
    },
    {
        name: '青海省',
        cities: [
            '西宁市',
            '海东市',
            '海北藏族自治州',
            '黄南藏族自治州',
            '海南藏族自治州',
            '果洛藏族自治州',
            '玉树藏族自治州',
            '海西蒙古族藏族自治州',
        ],
    },
    { name: '宁夏', cities: ['银川市', '石嘴山市', '吴忠市', '固原市', '中卫市'] },
    {
        name: '新疆',
        cities: [
            '乌鲁木齐市',
            '克拉玛依市',
            '吐鲁番市',
            '哈密市',
            '昌吉回族自治州',
            '博尔塔拉蒙古自治州',
            '巴音郭楞蒙古自治州',
            '阿克苏地区',
            '克孜勒苏柯尔克孜自治州',
            '喀什地区',
            '和田地区',
            '伊犁哈萨克自治州',
            '塔城地区',
            '阿勒泰地区',
        ],
    },
    { name: '台湾省', cities: [] },
    { name: '香港', cities: [] },
    { name: '澳门', cities: [] },
    { name: '海外', cities: [] },
];
var ProvinceCitySelect = /** @class */ (function (_super) {
    __extends(ProvinceCitySelect, _super);
    function ProvinceCitySelect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectProvince: '',
        };
        return _this;
    }
    ProvinceCitySelect.prototype.render = function () {
        var _this = this;
        var provinces = provincesAndCities.map(function (provinces, name) {
            return React.createElement("option", { key: name }, provinces.name);
        });
        var cityList = provincesAndCities.find(function (item) { return item.name === _this.props.provinceValue; });
        var cityComponents = cityList && cityList.cities.map(function (item, index) { return React.createElement("option", { key: index }, item); });
        var isCityOptionVisible = (cityList && cityList.cities.length > 0 && this.props.provinceValue !== '请选择') || false;
        return (React.createElement(Container, null,
            React.createElement(Flex, { direction: "row", justify: "start" },
                React.createElement(LabelProvice, { isCityOptionVisible: isCityOptionVisible },
                    React.createElement(Flex, { direction: "row", justify: "start" },
                        React.createElement(SelectProvice, { value: this.props.provinceValue, onChange: this.props.onProvinceChange },
                            React.createElement("option", { disabled: true }, "\u8BF7\u9009\u62E9"),
                            provinces))),
                isCityOptionVisible && (React.createElement(LabelCity, null,
                    React.createElement(Flex, { direction: "row", justify: "start" },
                        React.createElement(SelectCity, { value: this.props.cityValue, onChange: this.props.onCityChange },
                            React.createElement("option", { disabled: true }, "\u8BF7\u9009\u62E9"),
                            cityComponents)))))));
    };
    return ProvinceCitySelect;
}(Component));
export { ProvinceCitySelect };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=ProvinceCitySelect.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/ProvinceCitySelect.js
// module id = 1225
// module chunks = 0